import React from "react";
import { Link, NavLink } from "react-router-dom";

const links = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/guides", label: "Repair Guides", testid: "nav-guides" },
  { to: "/services", label: "1:1 Services", testid: "nav-services" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/inquire", label: "Inquire", testid: "nav-inquire" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-brand-bg/85 border-b border-brand-border">
      <nav className="container-edit flex items-center justify-between py-5">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-serif text-2xl tracking-tight text-brand-forest leading-none"
        >
          The Trauma-Aware
          <span className="block text-xs font-sans uppercase tracking-[0.25em] text-brand-muted mt-1">
            Nursery Nurse
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                data-testid={l.testid}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `text-sm font-medium tracking-wide transition-colors ${
                    isActive
                      ? "text-brand-forest"
                      : "text-brand-muted hover:text-brand-forest"
                  }`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <Link
          to="/inquire"
          data-testid="nav-book-consultation"
          className="hidden md:inline-flex items-center px-5 py-3 bg-brand-terracotta text-brand-bg text-sm font-medium tracking-wide hover:bg-brand-terracottaDark transition-colors rounded-sm"
        >
          Book a Consultation
        </Link>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-brand-forest"
          aria-label="Toggle menu"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            {open ? (
              <path d="M6 6l12 12M6 18L18 6" />
            ) : (
              <path d="M4 7h16M4 12h16M4 17h16" />
            )}
          </svg>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-brand-border bg-brand-bg">
          <ul className="container-edit py-6 flex flex-col gap-5">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`${l.testid}-mobile`}
                  className="text-base text-brand-forest"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/inquire"
                onClick={() => setOpen(false)}
                data-testid="nav-book-consultation-mobile"
                className="inline-flex items-center px-5 py-3 bg-brand-terracotta text-brand-bg text-sm rounded-sm"
              >
                Book a Consultation
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
